import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import facebookLike from '../../assets/svg/fb-logo-white.svg'

const VISIT_URL = 'https://visit.mysmartjourney.co'
const facebookShareUrl = (appId, tokenId, cardId) => {
  const facebookShare = 'https://www.facebook.com/sharer/sharer.php?u='
  const utmMedium = parseInt(tokenId, 10) ? `jeton-${tokenId}` : `carte-${cardId}`
  const utm = `?utm_source=facebook&utm_medium=${utmMedium}&utm_campaign=facebook-share-button`
  let urlToShare

  if (parseInt(tokenId, 10) !== parseInt(cardId, 10)) { // unlinked card
    urlToShare = encodeURIComponent(`${VISIT_URL}/${appId}/card/${cardId}/${utm}`)
  } else {
    urlToShare = encodeURIComponent(`${VISIT_URL}/${appId}/${tokenId}/${utm}`)
  }
  return `${facebookShare}${urlToShare}`
}

const FBButton = styled.a`
  display: inline-block;
  background: #4267b2;
  position: relative;
  padding: 6px 6px 12px 52px;
  height: 42px;
  border-radius: 4px;
  transition: background .5s, box-shadow .5s;
  img{
    height: 30px;
    width: 30px;
    display: block;
    position: absolute;
    margin-left: -46px;
  }
  span{
    color: #fff;
    font-family: arial;
    line-height: 32px;
    padding-right: 10px;
  }
  &:hover{
    background: #4d71bb;
    text-decoration: none;
    box-shadow: inset 0px 3px 11px rgba(0, 0, 0, 0.2);
  }
  &:focus,&:active{
    outline: 4px solid #4267b229;
  }
`

const FacebookButton = ({ text, tokenId, cardId, appId }) => (
  <FBButton
    href={facebookShareUrl(appId, tokenId, cardId)}
    target="_blank"
  >
    <img src={facebookLike} alt="Facebook like thumbs up" />
    <span>{text}</span>
  </FBButton>
)

FacebookButton.propTypes = {
  text: PropTypes.string,
  tokenId: PropTypes.any,
  cardId: PropTypes.any,
  appId: PropTypes.string,
}

export default FacebookButton



// WEBPACK FOOTER //
// ./src/containers/GetCardContent/FacebookButton.js